import React from "react";
import { observer, inject } from "mobx-react";
import { $util, $const } from "../../helper";
import { Tooltip } from "antd";

import Language from "../language/language";

import "./stylesheets/user.scss";

@inject(
  "authStore",
  "languageStore",
  "teamStore",
  "personGameStore",
  "commonStore"
)
@observer
export default class User extends React.Component {
  goToPerson = () => {
    this.props.commonStore.gTag("event", "editProfile", {
      pageName: $util.getPageName(),
      buttonName: "editProfile",
    });
    window.location.href = $util.getPersonCenterUrl(
      this.props.languageStore.lang
    );
  };
  componentDidMount() {
    if (this.props.teamStore.myTeams.length < 1) {
      this.props.teamStore.getMyTeams();
    }
    if (this.props.personGameStore.myEvents.length < 1) {
      this.props.personGameStore.getEvents();
    }
  }

  getTermsNum = (teams, type) => {
    let num = 0;
    teams.length > 0 &&
      teams.forEach((team) => {
        if (
          team.gevent &&
          team.gevent.category &&
          team.gevent.category.registrationSourceType === type
        ) {
          num++;
        }
      });
    this.props.teamStore.myApplication.length > 0 &&
      this.props.teamStore.myApplication.forEach((application) => {
        // 有注册
        if (
          application.status === $const.TEAM_APPLICATION_STATUS.PENDING &&
          application.team &&
          application.team.gevent &&
          application.team.gevent.category &&
          application.team.gevent.category.registrationSourceType === type
        ) {
          num++;
        }
      });
    return num;
  };

  render() {
    let user = this.props.authStore.user;
    if (!user) {
      return null;
    }
    let teamsNum = this.getTermsNum(
      this.props.teamStore.myTeams,
      $const.EVENT_TYPE.TEAM
    );
    let personsNum = this.props.personGameStore.myEvents.length;
    return (
      <div id="user">
        <div className="container">
          <div className="avatar">
            <img
              alt={user.nickname}
              src={
                $util.getSafePicUrl(user.avatar)
                  ? $util.getSafePicUrl(user.avatar)
                  : $const.DEFAULT_AVATAR
              }
            />
          </div>
          <div className="info">
            <div className="name">
              <Tooltip title={user.nickname}>{user.nickname}</Tooltip>
            </div>
            <div className="registartion-info">
              <ul>
                <li>
                  <Language resource="MY_GAMES" />: {teamsNum}
                </li>
                <li>
                  <Language resource="MY_TEAMS" />: {personsNum}
                </li>
              </ul>
            </div>
          </div>
          <div className="spe-link" onClick={this.goToPerson}>
            <Language resource="EDIT_INFO" />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/user/user.js